import {Component, Injector, ViewChild, ViewEncapsulation, AfterViewInit, OnInit, OnDestroy} from '@angular/core';
import { appModuleAnimation } from '@axilla/axilla-shared';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    OrderGuideSimpleDto,
    OrderGuideTemplateDto,
    PagedResultDtoOfOrderGuideTemplateDto
} from '@shared/service-proxies/service-proxies';
import { Paginator } from 'primeng/paginator';
import { Table } from 'primeng/table';
import {Subject} from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import {AppSessionService} from '@axilla/axilla-shared';
import {OrderState, OrderStateService} from '@app/webshop/field-agent/shared/services/order-state.service';
import {FieldAgentOrderService} from '@app/webshop/field-agent/shared/services/field-agent-order.service';
import {Router} from '@angular/router';
import {NgxSpinnerService} from '@node_modules/ngx-spinner';


@Component({
    templateUrl: './field-agent-dashboard.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./field-agent-dashboard.component.less'],
    animations: [appModuleAnimation()]
})
export class FieldAgentDashboardComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {
    spinnerService: NgxSpinnerService;

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    protected readonly destroy$ = new Subject<void>(); // Used to signal unsubscription
    isShowContinue: boolean;

    get brandsValue(): OrderGuideSimpleDto[] {
        return this._fieldAgentOrderService.brandsValue;
    }

    get selectedBrand(): OrderGuideSimpleDto | undefined {
        return this._fieldAgentOrderService.selectedBrand;
    }

    selectedOrderGuideTemplate: OrderGuideTemplateDto | undefined;

    constructor(
        injector: Injector,
        private _sessionService: AppSessionService,
        private _orderStateService: OrderStateService,
        private _fieldAgentOrderService: FieldAgentOrderService,
        private _router: Router
    ) {
        super(injector);

        this.spinnerService = injector.get(NgxSpinnerService);
    }

    ngOnInit(): void {
        this.getUserOrderGuides();

        this._fieldAgentOrderService.selectedBrand$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe(selectedBrand => {
                if (selectedBrand) {
                    this.primengTableHelper.showLoadingIndicator();
                    this.getOrderGuideTemplates();
                }
            });

        this._fieldAgentOrderService.orderGuideTemplates$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe(templates => {
                if (templates) {
                    this.primengTableHelper.records = templates;
                    this.primengTableHelper.totalRecordsCount = templates.length;
                    this.primengTableHelper.hideLoadingIndicator();
                }
            });

        this._fieldAgentOrderService.orderPreparationReady$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe(ready => {
               this.isShowContinue = ready;
                if (ready) {
                    if (this._orderStateService.getCurrentState() === OrderState.SelectTemplates) {
                        setTimeout(() => {
                            if (location.pathname.startsWith('/app/webshop/field-agent/select-templates')) {
                                this.beginOrdering();
                            }
                        }, 2000);
                    }
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get ous(): number[] {
        return this._sessionService.user.organizationUnits;
    }

    ngAfterViewInit(): void {
        this.primengTableHelper.adjustScroll(this.dataTable);
    }

    getUserOrderGuides(event?: any) {
        this.spinnerService.show();
        this._fieldAgentOrderService.getUserOrderGuides$()
            .subscribe((result: OrderGuideSimpleDto[]) => {
                //console.log(result);
                this.spinnerService.hide();
            });
    }

    getOrderGuideTemplates(event?: any) {
        this._fieldAgentOrderService.getOrderGuideTemplates$(
                undefined,
                0,
                100
            )
            .subscribe((result: PagedResultDtoOfOrderGuideTemplateDto) => {
                //console.log(result);
            });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    onBrandSelect(brand: OrderGuideSimpleDto) {
        this._fieldAgentOrderService.unselectOrderGuideTemplate();
        this.selectedOrderGuideTemplate = undefined;

        this._fieldAgentOrderService.selectBrand(brand);
    }

    onTemplateSelect(event: any) {
        if (this.selectedOrderGuideTemplate) {
            this._fieldAgentOrderService.selectOrderGuideTemplate(this.selectedOrderGuideTemplate);
        }
    }

    onTemplateUnselect(event: any) {
        this._fieldAgentOrderService.unselectOrderGuideTemplate();
    }

    beginOrdering() {
        abp.message.confirm(
            'Do you want to continue?'
            , 'Selecting Templates'
            , (result: boolean) => {
                if (result) {
                    this.continue();
                }
            }
            , {
                showCloseButton: true,
                    customClass: {
                    container: 'modal-like'
                }
            });
    }

    continue() {
        this._fieldAgentOrderService.navigateToSelectProducts();
        this._orderStateService.selectProducts();
    }

}
